import { isElementInViewport } from '@theme/utilities';

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    /* Reflet : le pied de page du thème est désactivé, la fin de page est la section « reflet-fin »
       (data-rf-fin). Sans repli, footer = null et isElementInViewport plantait à chaque scroll. */
    this.footer = document.querySelector('[data-ref="footer"]') || document.querySelector('[data-rf-fin]');
    this.onScroll = () => this.#displayStickyAddToCart();

    this.#displayStickyAddToCart();

    window.addEventListener('scroll', this.onScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  #displayStickyAddToCart() {
    const formVisible = this.form ? isElementInViewport(this.form) : false;
    const footerVisible = this.footer ? isElementInViewport(this.footer) : false;
    if (formVisible || footerVisible) {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
    } else {
      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
